import ButtonDesigned from '../../../../../../components/UI-Elements/Buttons/ButtonDesigned';
import React from 'react';

export const CoRefineButtonSection: React.FC<buttonProps> = ({ updateDataFunction, cancelFunction }) => {
  return (
    <div className="flex justify-end space-x-[1rem] ">
      <ButtonDesigned
        className="end"
        style="outline"
        onButtonClick={() => {
          cancelFunction();
        }}
        backButton={true}
      ></ButtonDesigned>
      <ButtonDesigned
        className="end"
        style="outline"
        onButtonClick={() => {
          updateDataFunction();
        }}
      >
        Update
      </ButtonDesigned>
    </div>
  );
};
interface buttonProps {
  cancelFunction: () => void;
  updateDataFunction: () => void;
}
